import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { Urls } from '../../../apiConnection/urls';
import { CustomDeleteComponent } from '../../../components/custom-delete/custom-delete.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '@/apiConnection/ApiService';
import { DocumentRelation, DocumentRelationChipsComponent } from '@/components/document-relation-chips/document-relation-chips.component';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
    CentToEurDisplayDirective,
    ReactiveFormsModule,
    DocumentRelationChipsComponent,
  ],
  templateUrl: './purchases-list.page.html',
  styleUrl: './purchases-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class PurchaseListPage {

  @ViewChild('sauTable')
  sauTable: { refresh: () => void; getItems: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  loading = false;
  orientation: "dynamic" | "horizontal" | "vertical" = 'dynamic'
  showOptions = true

  public url = Urls.urls.purchases;
  public saveForm: FormGroup = new FormGroup({});

  public headers = [
    { name: 'Número', key: 'type' },
    { name: 'Proveedor', key: 'provider.name' },
    { name: 'Total', key: 'total' },
    { name: 'Fecha', key: 'date', type: 'dateTime' },
    { name: 'Relación', key: 'relations' },
  ];

  relationLink(rel: DocumentRelation): string {
    return `/purchase/edit/${rel.id}`;
  }

  public filterConfig: any = {
    orderParamName: 'sort',
    orderByFields: [
      { field: 'created_at', label: 'Fecha' },
      { field: 'total', label: 'Total' },
    ],
    order: ['type', 'dateRange', 'provider', 'product'],
    mobile: ['type', 'dateRange'],
    form: {
      type: {
        name: 'Estado',
        key: 'status_id',
        type: 'selectSimple',
        dropdowns: [
          { id: 'all', name: 'Todos' },
          { id: 'factura', name: 'Facturas' },
          { id: 'albaran', name: 'Albaranes' },
          { id: 'devolucion', name: 'Devoluciones' },
        ],
        defaultValue: 'all'
      },
      dateRange: {
        name: 'Periodo',
        key: 'date_start',
        keyTo: 'date_end',
        type: 'dateRange',
        defaultValue: []
      },
      provider: {
        name: 'Poveedor',
        key: 'provider_id',
        type: 'selectSimple',
        dropdowns: [],
      },
      product: {
        name: 'Producto',
        key: 'product_id',
        type: 'selectSimple',
        dropdowns: [],
      },
    }
  };

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
  ) { }

  showEditAndDeleteButtons(): boolean {
    return true;
  }

  toggleEditForm(item: { id: number }) {
    this.router.navigate(['/purchase/edit', item.id]);
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'compra';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  ngOnInit(): void {
    this.createForm();
    this.getDropdowns();
  }

  createForm() {
    this.saveForm = new FormGroup({
      typeFilter: new FormControl('all'),
      dateStart: new FormControl(null),
      dateEnd: new FormControl(null),
      provider_id: new FormControl(null),
      products: new FormControl(null),
    })
  };

  updateUrl(): void {
    const typeFilter = this.saveForm.get('typeFilter')?.value;
    const dateStart = this.saveForm.get('dateStart')?.value;
    const dateEnd = this.saveForm.get('dateEnd')?.value;
    const providerId = this.saveForm.get('provider_id')?.value;
    const products = this.saveForm.get('products')?.value;

    let params = [];

    if (typeFilter && typeFilter !== 'all') {
      params.push('types=' + typeFilter);
    }
    if (dateStart) {
      params.push('date_start=' + dateStart);
    }
    if (dateEnd) {
      params.push('date_end=' + dateEnd);
    }
    if (providerId) {
      params.push('provider_id=' + providerId);
    }
    if (products) {
      params.push('products=' + products);
    }
    this.url = Urls.urls.purchases + "/filters" + (params.length > 0 ? '?' + params.join('&') : '');
  }

  onSubmit(): void {
    this.updateUrl();
    this.cdr.detectChanges();
    this.sauTable?.refresh();
  }

  getDropdowns() {
    const config = { providers: {}, products: {} };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {

        this.filterConfig.form.provider.dropdowns.push(...data.providers || [])
        this.filterConfig.form.product.dropdowns.push(...data.products || []);

        this.cdr.detectChanges();
      }
    });
  }

}
